<template>
  <div class="paginator" v-if="drawableData.length > 1">

    <nav class="nav-paginator">

      <ul class="pagination pagination-sm mb-0" :class="sizeClass">

        <li class="page-item"
            @click="onFirstPageClick"
            :class="{ 'disabled': pagination.page === 1 }">
          <span class="page-link">«</span>
        </li>

        <li class="page-item"
            @click="onPreviousPageClick"
            :class="{ 'disabled': pagination.page === 1 }">
          <span class="page-link">‹</span>
        </li>

        <template v-for="page in drawableData">
          <li class="page-item"
              :key="page"
              @click="onPageClick(page)"
              :class="{ 'active': pagination.page === page, 'disabled': isNaN(page) }">
            <span class="page-link">{{ page }}</span>
          </li>
        </template>

        <li class="page-item"
            :class="{ 'disabled': pagination.page === totalPagesCount }">
          <span class="page-link" @click="onNextPageClick">›</span>
        </li>

        <li class="page-item"
            :class="{ 'disabled': pagination.page === totalPagesCount }">
          <span class="page-link" @click="onLastPageClick">»</span>
        </li>

      </ul>
    </nav>

  </div>

</template>

<script>

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    props: {
      pagination: Object,
      size: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        maxNumberButtonsCount: 7,
      }
    },
    methods: {
      onNextPageClick() {
        this.updatePaginator(this.pagination.page + 1);
      },
      onPreviousPageClick() {
        this.updatePaginator(this.pagination.page - 1);
      },
      onLastPageClick() {
        this.updatePaginator(this.totalPagesCount);
      },
      onFirstPageClick() {
        this.updatePaginator(1);
      },
      onPageClick(pageIndex) {
        this.updatePaginator(pageIndex);
      },
      updatePaginator(pageIndex) {
        if (
          pageIndex !== this.pagination.page
          && !isNaN(pageIndex)
          && (pageIndex >= 1 && pageIndex <= this.totalPagesCount)
        ) {
          this.$emit('pageChange', pageIndex)
        }
      }
    },
    computed: {
      sizeClass() {
        if (this.size === 'lg') {
          return 'pagination-lg';
        } else if (this.size === 'sm') {
          return 'pagination-sm';
        }
        return '';
      },
      totalPagesCount() {
        return Math.ceil(this.pagination.total / this.pagination.limit);
      },
      drawableData() {
        const arr = [];
        let range = [];
        let delta = 2;

        let left = this.pagination.page - delta;
        let right = this.pagination.page + delta + 1;

        for (let i = 1; i <= this.totalPagesCount; i++) {
          if (i === 1 || i === this.totalPagesCount || i >= left && i < right) {
            range.push(i);
          }
        }

        let tmp;

        for (let i of range) {
          if (tmp) {
            if (i - tmp === 2) {
              arr.push(tmp + 1);
            } else if (i - tmp !== 1) {
              arr.push(`...${i}`);
            }
          }

          arr.push(i);
          tmp = i;
        }
        return arr;
      },
    }
  }
</script>

<style lang="scss">
  @import "./../../scss/index";

  .nav-paginator {
    display: $paginator-display;

    ul {
      li {
        cursor: $paginator-ul-li-cursor !important;
      }

      li.disabled {
        cursor: $paginator-ul-li-disabled-cursor !important;
      }
    }
  }
</style>
